<mat-card class="booking-card" [routerLink]="['/bookings', booking.id]">
  <mat-card-content class="booking-content">
    <div class="booking-top">
      <span class="card-type-badge" *ngIf="showTypeBadge">Бронь</span>
      <ng-container *ngIf="showCarInfo">
        <span class="car-info">
          <span class="booking-car">{{ booking.car_title }}</span>
          <span class="booking-plate" *ngIf="booking.license_plate">{{ booking.license_plate }}</span>
        </span>
      </ng-container>
      <mat-chip-set class="booking-chip">
        <mat-chip [class]="'status-' + booking.status" selected>
          {{ booking.status | statusLabel:'booking' }}
        </mat-chip>
      </mat-chip-set>
    </div>
    <div class="booking-info">
      <span class="booking-client">{{ booking.client_name }}</span>
      <span class="booking-dates">{{ formatDateTime(booking.start_date) }} — {{ formatDateTime(booking.end_date) }}</span>
    </div>
  </mat-card-content>
</mat-card>
